import { render } from "./IconMenuPreviewComponent.vue?vue&type=template&id=42b43437&ts=true"
import script from "./IconMenuPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./IconMenuPreviewComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__